import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Bicycle1_md = (props) => {
    const width = props.width ? props.width + 'px' : '24px';
    const height = props.height ? props.height + 'px' : '24px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 24 24"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.27962 5.09566C8.16619 4.3864 9.26775 4 10.4031 4L13.5968 4C14.7322 4 15.8338 4.3864 16.7203 5.09566L18.1247 6.21914C18.5559 6.56415 18.6259 7.19344 18.2808 7.6247C17.9358 8.05596 17.3065 8.12588 16.8753 7.78087L15.4709 6.6574C14.939 6.23184 14.2781 6 13.5968 6H10.4031C9.72189 6 9.06095 6.23184 8.52901 6.6574L7.12467 7.78087C6.69341 8.12588 6.06412 8.05596 5.71911 7.6247C5.3741 7.19344 5.44402 6.56415 5.87528 6.21914L7.27962 5.09566ZM12 6C12.5522 6 13 6.44772 13 7V8.5C13 9.05229 12.5522 9.5 12 9.5C11.4477 9.5 11 9.05229 11 8.5V7C11 6.44772 11.4477 6 12 6ZM12.4338 12.4541C12.1481 12.3906 11.8519 12.3906 11.5661 12.4541C10.651 12.6575 9.99998 13.4691 9.99998 14.4065V18.3333C9.99998 18.8856 9.55226 19.3333 8.99998 19.3333C8.44769 19.3333 7.99998 18.8856 7.99998 18.3333V14.4065C7.99998 12.5317 9.3021 10.9085 11.1323 10.5018C11.7038 10.3748 12.2962 10.3748 12.8677 10.5018C14.6978 10.9085 16 12.5317 16 14.4065V18.3333C16 18.8856 15.5523 19.3333 15 19.3333C14.4477 19.3333 14 18.8856 14 18.3333V14.4065C14 13.4691 13.3489 12.6575 12.4338 12.4541ZM12 14C12.5523 14 13 14.4477 13 15V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V15C11 14.4477 11.4477 14 12 14Z"
            />
        </SvgStyled>
    );
};

export default Bicycle1_md;
